import Api from "../services/Api";
import { getAuthHeader } from "../services/GetAuth";

export const getServices = async (scanId: string, subdomain: string) => {
  const config = await getAuthHeader();

  return Api.get(`/services?scanId=${scanId}&subdomain=${subdomain}`, config);
}